var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon-search",
    clipPath: "url(#clip0_784_5396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_784_5396",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-search_a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H20V20H0V0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_784_5396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 75427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon feather-search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 26707",
    d: "M9.08909 0.833252C10.7219 0.833252 12.3181 1.31745 13.6758 2.22461C15.0334 3.13177 16.0916 4.42116 16.7165 5.92971C17.3413 7.43827 17.5048 9.09824 17.1863 10.6997C16.8677 12.3012 16.0814 13.7722 14.9268 14.9268C13.7722 16.0814 12.3012 16.8677 10.6997 17.1863C9.09824 17.5048 7.43827 17.3413 5.92971 16.7165C4.42116 16.0916 3.13177 15.0334 2.22461 13.6758C1.31745 12.3181 0.833252 10.7219 0.833252 9.08909C0.835898 6.90031 1.70656 4.80195 3.25425 3.25425C4.80195 1.70656 6.90031 0.835898 9.08909 0.833252ZM9.08909 15.4024C10.3377 15.4024 11.5584 15.0321 12.5966 14.3384C13.6348 13.6447 14.444 12.6587 14.9218 11.5051C15.3997 10.3515 15.5247 9.08208 15.2811 7.85742C15.0375 6.63275 14.4362 5.50782 13.5533 4.62488C12.6704 3.74195 11.5454 3.14066 10.3208 2.89706C9.09609 2.65346 7.82669 2.77848 6.67308 3.25633C5.51947 3.73417 4.53346 4.54336 3.83974 5.58159C3.14602 6.61981 2.77575 7.84043 2.77575 9.08909C2.77752 10.7629 3.44324 12.3677 4.62683 13.5513C5.81043 14.7349 7.41523 15.4007 9.08909 15.4024Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 26708",
    d: "M18.195 19.1667C18.0675 19.1669 17.9412 19.1419 17.8234 19.0931C17.7055 19.0444 17.5985 18.9728 17.5084 18.8825L13.5475 14.9217C13.3653 14.7395 13.2629 14.4923 13.2629 14.2346C13.2629 13.9769 13.3653 13.7298 13.5475 13.5475C13.7298 13.3653 13.9769 13.2629 14.2346 13.2629C14.4923 13.2629 14.7395 13.3653 14.9217 13.5475L18.8825 17.5084C19.0183 17.6443 19.1107 17.8173 19.1481 18.0057C19.1855 18.1941 19.1663 18.3893 19.0928 18.5668C19.0193 18.7442 18.8949 18.8959 18.7353 19.0027C18.5756 19.1095 18.3871 19.1665 18.195 19.1667Z"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_784_5396"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.c88550b677e5f883ad55f5b95b201178.svg";
export { ForwardRef as ReactComponent };